import { ModalShareDataModel } from '@src/core/domain/modal-share-data/modal-share-data.model';
import { Observable } from 'rxjs';

export abstract class ModalShareDataRepositories {
  abstract postData(body: any): Observable<ModalShareDataModel>;
}
